import { Copy, MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { drivetrainById, styleText } from "@/rc/drivetrains";
import { ATTACH_KINDS } from "@/rc/attachments";
import { RobotDiagram } from "@/components/rc/RobotDiagram";

export const ProjectCard = ({ project, edited, onOpen, onRename, onDuplicate, onDelete }) => {
  const { config, id } = project;
  const dt = drivetrainById(config.drivetrain);
  const atts = config.attachments || [];
  return (
    <div className="rc-card lift group flex flex-col rounded-2xl border bg-card p-5" data-testid={`project-card-${id}`}>
      <div className="flex items-start justify-between gap-2">
        <span className="flex h-20 w-20 items-center justify-center rounded-xl bg-muted/60 p-2.5"><RobotDiagram dt={dt} className="h-full w-full" /></span>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="rounded-full" data-testid={`project-menu-${id}`} aria-label="Project options">
              <MoreHorizontal className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={onRename} data-testid={`project-rename-${id}`}><Pencil className="mr-2 h-4 w-4" />Rename</DropdownMenuItem>
            <DropdownMenuItem onClick={onDuplicate} data-testid={`project-duplicate-${id}`}><Copy className="mr-2 h-4 w-4" />Duplicate</DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onDelete} className="text-destructive focus:text-destructive" data-testid={`project-delete-${id}`}><Trash2 className="mr-2 h-4 w-4" />Delete</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <button onClick={onOpen} className="mt-4 flex-1 text-left" data-testid={`project-open-${id}`}>
        <p className="line-clamp-2 font-display text-lg font-bold transition-colors group-hover:text-primary" data-testid={`project-name-${id}`}>{project.name}</p>
        <p className="mt-1 text-sm text-muted-foreground" data-testid={`project-summary-${id}`}>
          {dt.name} · {styleText(config.style, dt.kind).name}
          {atts.length ? ` · ${atts.map((a) => ATTACH_KINDS[a.kind]?.name || "Attachment").join(", ")}` : ""}
        </p>
        <p className="mt-2 text-xs text-muted-foreground">Edited {edited}</p>
      </button>
      <Button variant="secondary" className="mt-5 rounded-full" onClick={onOpen} data-testid={`project-open-button-${id}`}>Open</Button>
    </div>
  );
};
